/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progression_Rpe_AnomalyInputs */

const en_us2_progression_rpe_anomaly = /** @type {(inputs: Progression_Rpe_AnomalyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load eased after a very heavy session`)
};

const pt_br2_progression_rpe_anomaly = /** @type {(inputs: Progression_Rpe_AnomalyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga aliviada depois de uma sessão muito pesada`)
};

const es_419_progression_rpe_anomaly = /** @type {(inputs: Progression_Rpe_AnomalyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso aliviado tras una sesión muy pesada`)
};

const pt_pt2_progression_rpe_anomaly = /** @type {(inputs: Progression_Rpe_AnomalyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga aliviada depois de uma sessão muito pesada`)
};

const fr_fr2_progression_rpe_anomaly = /** @type {(inputs: Progression_Rpe_AnomalyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charge allégée après une séance très dure`)
};

const de_de2_progression_rpe_anomaly = /** @type {(inputs: Progression_Rpe_AnomalyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht nach einer sehr schweren Einheit reduziert`)
};

const it_it2_progression_rpe_anomaly = /** @type {(inputs: Progression_Rpe_AnomalyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carico alleggerito dopo una sessione molto pesante`)
};

/**
* | output |
* | --- |
* | "Load eased after a very heavy session" |
*
* @param {Progression_Rpe_AnomalyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_rpe_anomaly = /** @type {((inputs?: Progression_Rpe_AnomalyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Rpe_AnomalyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_rpe_anomaly(inputs)
	if (locale === "es-419") return es_419_progression_rpe_anomaly(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_rpe_anomaly(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_rpe_anomaly(inputs)
	if (locale === "de-DE") return de_de2_progression_rpe_anomaly(inputs)
	if (locale === "it-IT") return it_it2_progression_rpe_anomaly(inputs)
	return en_us2_progression_rpe_anomaly(inputs)
});
export { progression_rpe_anomaly as "progression.rpe_anomaly" }